export var EReferralType;
(function (EReferralType) {
    EReferralType["ARB"] = "ARB";
    EReferralType["INVESTOR"] = "INVESTOR";
    EReferralType["STARTUP"] = "STARTUP";
    EReferralType["COMPANY"] = "COMPANY";
})(EReferralType || (EReferralType = {}));
